import type { Application } from 'renter/interfaces/api/application'
import ApplicantInfo from 'shared/components/CreditAndBackgroundCheck/components/ApplicantInfo'
import PublicRecords from 'shared/components/CreditAndBackgroundCheck/components/PublicRecords'
import CriminalRecordsSummary from './CriminalRecordsSummary'
import StateCriminalRecords from 'shared/components/CreditAndBackgroundCheck/components/StateCriminalRecords'
import { APPLICATION_COUNTY_CRIMINAL_SEARCH_STATUS } from 'shared/config/constants'

import {
  CountyCriminalRecordsProps,
  CreditScoreSummary,
  CriminalRecordsType,
} from 'shared/components/CreditAndBackgroundCheck/interfaces'
import { DealPartial } from 'shared/components/CreditAndBackgroundCheck/types'

const defaultCreditScoreSummary: Partial<{
  firstName: string
  middleName: string
  lastName: string
}> = {
  firstName: null,
  middleName: null,
  lastName: null,
}

type CriminalHistoryProps = {
  creditScoreSummary?: CreditScoreSummary
  criminalRecords?: CriminalRecordsType
  hideCriminalRecords: boolean
  canAccessCountyCriminalRecords?: boolean
  countyCriminalRecords?: CountyCriminalRecordsProps
  countyCriminalSearchStatus?: typeof APPLICATION_COUNTY_CRIMINAL_SEARCH_STATUS
  hasCountyCriminalSearch?: boolean
  hasTuCountyCriminalSearch?: boolean
  deal?: DealPartial | null
  application?: Application | null
}

const N_A = 'N/A'

const CriminalHistory = ({
  creditScoreSummary,
  criminalRecords,
  hideCriminalRecords,
  canAccessCountyCriminalRecords,
  countyCriminalRecords,
  countyCriminalSearchStatus,
  hasCountyCriminalSearch,
  hasTuCountyCriminalSearch,
  deal = null,
  application = null,
}: CriminalHistoryProps) => {
  const { firstName, middleName, lastName } =
    creditScoreSummary ?? defaultCreditScoreSummary

  const applicantFullName =
    !!firstName || !!lastName
      ? [firstName, middleName, lastName].filter(Boolean).join(' ')
      : N_A

  return (
    <>
      <ApplicantInfo
        creditScoreSummary={creditScoreSummary}
        deal={deal}
        applicantFullName={applicantFullName}
        application={application}
      />

      <CriminalRecordsSummary
        criminalRecords={criminalRecords}
        hideCriminalRecords={hideCriminalRecords}
      />

      <StateCriminalRecords
        canAccessCountyCriminalRecords={canAccessCountyCriminalRecords}
        countyCriminalRecords={countyCriminalRecords}
        countyCriminalSearchStatus={countyCriminalSearchStatus}
        criminalRecords={criminalRecords}
        hasCountyCriminalSearch={hasCountyCriminalSearch}
        hasTuCountyCriminalSearch={hasTuCountyCriminalSearch}
        hideCriminalRecords={hideCriminalRecords}
      />

      <PublicRecords creditScoreSummary={creditScoreSummary} />
    </>
  )
}

export default CriminalHistory